export class Channel
{
	channelId: number;
	channelDate: Date;
	syncEnabled: boolean | null;
}
